import React, { Fragment, useState } from "react";
import { Btn, H6, P } from "../../../../../AbstractElements";
import { ExtraLargeModals } from "../../../../../Constant";
import CommonModal from "../../Common/CommonModal";
import { ChevronsRight } from "react-feather";
import { FULLSCREEN_DATA } from "../../../../../Data/UiKit/Modal";

const ExtraLargeModal = () => {
  const [extraLargeScreen, setExtraLargeScreen] = useState(false);
  const extraLargeScreenToggle = () => setExtraLargeScreen(!extraLargeScreen);
  return (
    <>
      <Btn color="info" type="button" onClick={extraLargeScreenToggle}>{ExtraLargeModals}</Btn>
      <CommonModal size="xl" isOpen={extraLargeScreen} toggle={extraLargeScreenToggle} sizeTitle="Extra Large modal">
        <div className="large-modal-header"><ChevronsRight /><H6>Web Design </H6></div>
        <P className="modal-padding-space">We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI.</P>
        {FULLSCREEN_DATA.map(({ title, text }, index) => (
          <Fragment key={index}>
            <div className="large-modal-header"><ChevronsRight /><H6>{title}</H6></div>
            <P className="modal-padding-space">{text}</P>
          </Fragment>
        ))}
      </CommonModal>
    </>
  );
};

export default ExtraLargeModal;
